<div class="container">
  <div class="row">
    <div class="col">
      <div
        id="additional-resources"
        class="callout__container"
        style="--callout-accent-color: #ff5e2b"
      >
        <h2 class="mb-4 text-dark text-center text-lg-start">Additional resources</h2>
        <p class="mb-4 text-dark text-center text-lg-start">
          Several type 1 diabetes organizations offer detailed guidelines and
          resources that can help serve both doctors and patients. Visit the
          websites below for more information and guidelines on screening for
          T1D, and other information concerning T1D diagnosis and treatment.
        </p>
        <div class="callout__buttons d-flex flex-column flex-lg-row justify-content-center justify-content-lg-start align-items-center gap-3">
          <div class="callout__btn--1 mt-3">
            <div
              class="action-plan__btn"
              global-button
              [buttonData]="cardButton1"
            ></div>
          </div>
          <div class="callout__btn--2 mt-3">
            <div
              class="action-plan__btn"
              global-button
              [buttonData]="cardButton2"
            ></div>
          </div>
          <div class="callout__btn--3 mt-3">
            <div
              class="action-plan__btn"
              global-button
              [buttonData]="cardButton3"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
